import { render, staticRenderFns } from "./FieldRenderer.vue?vue&type=template&id=535bc0c8&scoped=true"
import script from "./FieldRenderer.vue?vue&type=script&lang=js"
export * from "./FieldRenderer.vue?vue&type=script&lang=js"
import style0 from "./FieldRenderer.vue?vue&type=style&index=0&id=535bc0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bc0c8",
  null
  
)

export default component.exports